// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"180":"4647e966","226":"e0e64212","330":"3679b76f","886":"db943cfe"}[chunkId] + ".chunk.js";
};